/* unplugin-vue-components disabled */import { render } from "./checkout-summary.vue?vue&type=template&id=cf3d0cb0"
import script from "./checkout-summary.vue?vue&type=script&lang=js"
export * from "./checkout-summary.vue?vue&type=script&lang=js"

import "./checkout-summary.vue?vue&type=style&index=0&id=cf3d0cb0&lang=scss"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__